import PropTypes from 'prop-types'
import React, { Fragment, useState } from 'react'
import { AnswerLines } from '../answers/AnswerLines'
import { getStateByCode, stateCodes } from '../../../configs/answerConfig'
import HtmlContent from '../../atoms/HtmlContent'
import TrackingAccordion from './TrackingAccordion'

const TrackingHistory = ({ confirmedAt, answerLines = [], statusHistory = [] }) => {
  const [expanded, setExpanded] = useState(statusHistory.length)
  const statusList = [
    {
      code: stateCodes.new,
      date: confirmedAt,
      hasTitle: true,
      renderContent: (
        <ol className="list-inside list-sub_index-decimal-bold">
          <AnswerLines data={answerLines} dispatch="Response" subChildrenClassName="mt-2" />
        </ol>
      )
    },
    ...statusHistory.map(step => ({
      code: step.label,
      date: step.date,
      renderContent: (
        <Fragment key={`status_${step.date}`}>
          <p className="font-bold mb-0">
            {step.label === stateCodes.observed ? 'Detalle de observación:' : 'Mensaje de la entidad:'}
          </p>
          <HtmlContent html={step.citizen_comment} />
        </Fragment>
      )
    }))
  ]

  const onChange = (index, open) => {
    setExpanded(open ? index : false)
  }

  return (
    <div className="mb-6">
      <div className="bg-neutral-350 px-6 py-4 flex justify-between md:rounded-t-xl">
        <div className="font-bold">Historial de la solicitud</div>
      </div>
      <div className="flex flex-col gap-6 md:rounded-b-xl overflow-hidden">
        {statusList.map((status, index) => (
          <TrackingAccordion
            key={index}
            index={index}
            date={status.date}
            title={getStateByCode(status.code).citizenName}
            content={status.renderContent}
            onChange={(_, open) => onChange(index, open)}
            expanded={expanded === index}
          />
        ))}
      </div>
    </div>
  )
}
export default TrackingHistory

TrackingHistory.propTypes = {
  confirmedAt: PropTypes.string,
  answerLines: PropTypes.array,
  statusHistory: PropTypes.array
}
